// src/Components/DeleteConfirmationModal.jsx
import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  TextField,
  Box,
  Typography
} from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const DeleteConfirmationModal = ({
  isOpen,
  open, // Accept both props for compatibility
  onClose,
  onConfirm,
  title = "Confirm Action",
  message,
  itemName,
  userName,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  requireReason = false, // ✅ pass true when cancel action
}) => {
  const [reason, setReason] = useState("");
  
  // Support both isOpen and open props
  const modalOpen = isOpen ?? open;

  const handleConfirm = () => {
    if (requireReason && !reason.trim()) {
      alert("Please provide a reason before confirming.");
      return;
    }
    onConfirm(reason); // ✅ pass reason back to parent
    setReason(""); // Reset reason after confirm
  };

  const handleClose = () => {
    setReason(""); // Reset reason on close
    onClose();
  };

  return (
    <Dialog
      open={modalOpen || false}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)'
        }
      }}
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        gap: 1,
        color: 'error.main',
        pb: 1
      }}>
        <WarningAmberIcon sx={{ fontSize: 28 }} />
        {title}
      </DialogTitle>
      
      <DialogContent>
        <DialogContentText sx={{ mb: requireReason ? 2 : 0 }}>
          {message ? (
            message
          ) : (
            <>
              Are you sure you want to proceed with{' '}
              <Box component="span" sx={{ fontWeight: 'bold' }}>
                {itemName || userName}
              </Box>
              ?
            </>
          )}
        </DialogContentText>

        {requireReason && (
          <TextField
            multiline
            rows={3}
            fullWidth
            placeholder="Enter reason for cancellation..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            variant="outlined"
            sx={{ mt: 2 }}
          />
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, gap: 1 }}>
        <Button 
          onClick={handleClose}
          variant="outlined"
          color="inherit"
        >
          {cancelLabel}
        </Button>
        <Button 
          onClick={handleConfirm}
          variant="contained"
          color="error"
          autoFocus
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
